/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Parq_All_NoInputs */

const en_us2_onboarding_parq_all_no = /** @type {(inputs: Onboarding_Parq_All_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No to all seven health questions`)
};

const pt_br2_onboarding_parq_all_no = /** @type {(inputs: Onboarding_Parq_All_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não para as sete perguntas de saúde`)
};

const es_419_onboarding_parq_all_no = /** @type {(inputs: Onboarding_Parq_All_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No a las siete preguntas de salud`)
};

const pt_pt2_onboarding_parq_all_no = /** @type {(inputs: Onboarding_Parq_All_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não às sete perguntas de saúde`)
};

const fr_fr2_onboarding_parq_all_no = /** @type {(inputs: Onboarding_Parq_All_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non aux sept questions de santé`)
};

const de_de2_onboarding_parq_all_no = /** @type {(inputs: Onboarding_Parq_All_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein bei allen sieben Gesundheitsfragen`)
};

const it_it2_onboarding_parq_all_no = /** @type {(inputs: Onboarding_Parq_All_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No a tutte e sette le domande sulla salute`)
};

/**
* | output |
* | --- |
* | "No to all seven health questions" |
*
* @param {Onboarding_Parq_All_NoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_parq_all_no = /** @type {((inputs?: Onboarding_Parq_All_NoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Parq_All_NoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_parq_all_no(inputs)
	if (locale === "es-419") return es_419_onboarding_parq_all_no(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_parq_all_no(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_parq_all_no(inputs)
	if (locale === "de-DE") return de_de2_onboarding_parq_all_no(inputs)
	if (locale === "it-IT") return it_it2_onboarding_parq_all_no(inputs)
	return en_us2_onboarding_parq_all_no(inputs)
});
export { onboarding_parq_all_no as "onboarding.parq.all_no" }